import AutocompleteMultiple from './component';

export default AutocompleteMultiple;
